function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

module.exports = _isString;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isString.js
// module id = 256
// module chunks = 0